import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import { mergeParams } from "../../../helpers/helpers";
import AppContext from "../../../container/context";
import ActionTable from "../../../components/table/ActionTable";
import ijws from "../../../services/ijws";
import { CircularProgress } from "@mui/material";

export default function Lista({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      { nivelId: 0, numero: 0, nome: "", exibirInativos: false },
      location
    )
  );
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [comboNivel, setComboNivel] = useState([]);
  const [unidades, setUnidades] = useState([]);

  useEffect(() => {
    if (filtros.nivelId || filtros.numero || filtros.nome) {
      carregar();
    }
    carregarComboNivel();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    ijws
      .get("admin/unidades/listar", filtrosEnviar)
      .then((res) => {
        setUnidades(res);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Erro ao listar os unidades");
        setCarregando(false);
      });
  };

  const carregarComboNivel = () => {
    ijws
      .get("admin/niveis/listar")
      .then((res) => {
        setComboNivel(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Erro ao listar os níveis");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nivelId: {
        label: "Nível",
        type: "select",
        value: filtros.nivelId,
        array: {
          data: comboNivel,
          value: "id",
          desc: "nome",
        },
        emptyItem: true,
        emptyItemText: "(Selecione)",
        space: 3,
        required: true,
      },

      nome: {
        label: "Nome",
        type: "text",
        value: filtros.nome,
        space: 4,
      },
      numero: {
        label: "Número",
        type: "text",
        value: filtros.numero,
        space: 2,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 3,
        value: filtros.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Unidades",
    newItemAction: () => history.push("/app/unidade-ij/0"),
    onLineClick: (id) => history.push(`/app/unidade-ij/${id}`),
    key: "id",

    columns: [
      {
        label: "Número",
        name: "numero",
      },
      {
        label: "Título",
        name: "titulo",
      },
      {
        label: "Nível",
        name: "nivelNome",
      },
    ],
    array: unidades,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
